import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import {analytics} from "@/firebase"

// import store from "./store"
import SetSearch from "./search/SetSearch.vue"
import SetHome from "./home/SetHome.vue"

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    //set
    {
        path: '/set',
        component: SetHome,
        props: true,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/set/:sym',
        component: SetSearch,
        props: true,
        meta: {
            requiresAuth: false
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

//uncomment when need login
// router.beforeEach(async (to, from, next) => {
//     //eslint-disable-next-line  @typescript-eslint/no-explicit-any
//     await (store as any).restored //need to wait for async state load to get user. see https://github.com/championswimmer/vuex-persist#how-to-know-when-async-store-has-been-replaced
//     const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
//     const user = store.state.user as UserState
//     // console.log('router: is signedIn: %o', user.signedIn)
//     if (requiresAuth && !user.signedIn) {
//         next('/edinet/signin')
//     } else {
//         next()
//     }
// })

router.afterEach(async (to) => {
    if (analytics){
        const pageViewEvent = {
            //eslint-disable-next-line  @typescript-eslint/camelcase
            page_location: location.href,
            //eslint-disable-next-line  @typescript-eslint/camelcase
            page_path: to.path,
            // page_title: document.title
            //eslint-disable-next-line  @typescript-eslint/camelcase
            page_title: to.path //actual title does not get updated until later, so use path for now
        }
        // console.log('page_view: %o', pageViewEvent)
        analytics.logEvent('page_view', pageViewEvent)
    }
})

export default router
